import { arrToCoord, isValidLonLat } from "@nova/calculate-geospatial"
import { selectSearchCoordinate } from "./selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { Marker } from "react-map-gl"

export const SearchMarker = () => {
    const searchCoordinate = useAppSelector(selectSearchCoordinate)
    if (!searchCoordinate || !isValidLonLat(arrToCoord(searchCoordinate))) return null
    return (
        <Marker longitude={searchCoordinate[0]} latitude={searchCoordinate[1]}>
            <svg data-src={"/images/pin-icon.svg"} height={40} width={35} />
        </Marker>
    )
}
